// Shared "render this capture payload" dispatch — used by both the Extension
// tab's inbox/paste-box import and the global ⌘+V paste handler, so every
// path attaches options identically and feeds the same CREATE_JSON_DESIGN
// render entry the File tab uses.
import { emit } from '../messaging';

export interface ImportOptions {
  useAutoLayout?: boolean;
  defaultFontFamily?: string;
  missingFontBehavior?: string;
  fontMappings?: unknown[];
}

/** Attach options to a captures array and hand it to the sandbox to render. */
export function importCapturePayload(payload: unknown, options: ImportOptions = {}): void {
  if (!Array.isArray(payload) || payload.length === 0) {
    throw new Error('Capture payload is not a pages array');
  }
  const data = JSON.parse(JSON.stringify(payload));
  data[0].options = {
    useAutoLayout: options.useAutoLayout !== false,
    defaultFontFamily: options.defaultFontFamily || 'Inter',
    missingFontBehavior: options.missingFontBehavior || 'replace',
    fontMappings: options.fontMappings || [],
  };
  emit('CREATE_JSON_DESIGN', data);
}
